<template>
  <div class="sideNavVue">
    <div>
      <div v-if="userRoleSlug == 'client-admin' ||
          userRoleSlug == 'power-user' ||
          userRoleSlug == 'employee' ||
          userRoleSlug == 'auditor'"
        class="o-sidenav mainSidenav"
      >
        <div class="o-logo-area">
          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer">
            <img src="static/assets/images/logo.png" />
          </a>

          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer" v-if="client_logo_url!=''&&client_logo_url!='NA'">
            <img class="o-client-logo" :src="client_logo_url" />
          </a>

          <el-tooltip content="MobileView" placement="right" effect="dark">
            <a
              href="javascript: void(0)"
              class="o-mainlogo"
            >
              <!-- v-if="userRoleSlug == 'employee' && isSteward"  -->
               <!-- Above line is commented from the above <a> element with respect to the requirement D/M switch is for all users -->
              <button
                v-if="deviceDetector"
                class="view-change-button"
                @click="changeViewDevice()"
              >
                M
              </button>
            </a>
          </el-tooltip>
        </div>
        <ul class="o-sidebar-menu o-sidebar-bg sidebar">
          <!-- getPower('jobEvent') -->
          <li
            v-if="
              getPower('jobEvent') &&
              (((isSteward == 1 || isDispatcher == 1) && userRoleSlug == 'employee') ||
                userRoleSlug != 'employee') && isFrelenceUser()" @click="goToJobList()"
          >
            <el-tooltip content="JobsEvents" placement="right" effect="dark">
              <router-link to="/jobList">
                  <span class="o-sidemenu-icon"
                      ><i class="fa fa-briefcase" aria-hidden="true"></i
                    ></span>
                    {{ $t("jobs_events") }}
              </router-link>
            </el-tooltip>
          </li>

          <!-- <li v-if="getPower('CallList') && isFrelenceUser()" @click="goToCalls()">
            <el-tooltip content="CallsList" placement="right" effect="dark">
              <router-link to="/callList"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-phone" aria-hidden="true"></i
                ></span>
                Calls</router-link
              >
            </el-tooltip>
          </li> -->

          <li v-if="userRoleSlug=='client-admin'||userRoleSlug=='power-user'"
            @click="goToEmployee911Availability()">
            <el-tooltip content="911Availability" placement="right" effect="dark">
              <router-link to="/911-availability"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-clock-o" aria-hidden="true"></i></span
                >911 Availability
              </router-link>
            </el-tooltip>
          </li>
          
          <!-- <el-tooltip class="item" effect="dark" content="Schedule" placement="left-end"></el-tooltip> -->
          <li
            v-if="getPower('schedule') && isFrelenceUser()"
            @click="goToScedule()"
          >
            <el-tooltip content="Schedule" placement="right" effect="dark">
              <router-link
                :to="{ name: 'Schedule', params: { empId: this.encodedEmpId } }"
                ><span class="o-sidemenu-icon">
                  <i class="fa fa-list-ol" aria-hidden="true"></i>
                </span>
                {{ $t("schedule") }}
              </router-link>
            </el-tooltip>
          </li>

          <li
            v-if="getPower('calender') && isFrelenceUser()"
            @click="goToCalendar()"
          >
            <el-tooltip content="Calendar" placement="right" effect="dark">
              <router-link to="/calendar">
                <span class="o-sidemenu-icon"
                  ><i class="fa fa-calendar" aria-hidden="true"></i></span
                >{{ $t("calendar") }}
              </router-link>
            </el-tooltip>
          </li>

          <li v-if="getPower('resume')" @click="goToResume()">
            <el-tooltip content="Resume" placement="right" effect="dark">
              <router-link to="/resume">
                <span class="o-sidemenu-icon">
                  <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                </span>
                {{ $t("resume") }}
              </router-link>
            </el-tooltip>
          </li>

          <li
            v-if="getPower('employer') && isFrelenceUser()"
            @click="goToEmployers()"
          >
            <el-tooltip content="Employer" placement="right" effect="dark">
              <router-link to="/employerList"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-user" aria-hidden="true"></i></span
                >{{ $t("employers") }}
              </router-link>
            </el-tooltip>
          </li>

          <li v-if="getPower('payrole') && isFrelenceUser()">
            <el-tooltip content="Payroll" placement="right" effect="dark">
              <router-link to=""
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-building-o" aria-hidden="true"></i
                ></span>
                {{ $t("payroll") }}</router-link
              >
            </el-tooltip>
          </li>

          <li v-if="getPower('venue')" @click="goToVenue()">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <router-link to="/venue"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-map-marker" aria-hidden="true"></i
                ></span>
                {{ $t("venue") }}</router-link
              >
            </el-tooltip>
          </li>

          <li v-if="getPower('employees')" @click="goToEmployees()">
            <el-tooltip content="Employees" placement="right" effect="dark">
              <router-link to="/employees"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-users" aria-hidden="true"></i></span
                >{{ $t("employees") }}
              </router-link>
            </el-tooltip>
          </li>

          <li v-if="getPower('dailySchedule')" @click="goToDailySchedule()">
            <el-tooltip content="DailySchedule" placement="right" effect="dark">
              <router-link to="/dailySchedule"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-calendar-plus-o" aria-hidden="true"></i></span
                >{{ $t("daily_schedule") }}</router-link
              >
            </el-tooltip>
          </li>

          <li v-if="getPower('skills')" @click="goToSkills()">
            <el-tooltip content="Skills" placement="right" effect="dark">
              <router-link to="/skills"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-wrench" aria-hidden="true"></i
                ></span>
                {{ $t("skills") }}</router-link
              >
            </el-tooltip>
          </li>

          <li v-if="getPower('files')" @click="goToFiles()">
            <el-tooltip content="Files" placement="right" effect="dark">
              <router-link to="/files"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-folder" aria-hidden="true"></i
                ></span>
                {{ $t("files") }}</router-link
              >
            </el-tooltip>
          </li>

          <!-- <li v-if="getPower('report') && isFrelenceUser()" @click="goToReport()"><router-link to="/reportList"><span class="o-sidemenu-icon"><i class="fa fa-file-o" aria-hidden="true"></i></span> Report</router-link></li> -->
          <li
            v-if="getPower('report') && isFrelenceUser()"
            @click="goToReport()"
          >
            <el-tooltip content="Reports" placement="right" effect="dark">
              <router-link to="/new-report-list"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-file-o" aria-hidden="true"></i></span
                >{{ $t("report") }}</router-link
              >
            </el-tooltip>
          </li>

          <li
            v-if="
              getPower('notify') &&
              ((isSteward == 1 && userRoleSlug == 'employee') ||
                userRoleSlug != 'employee')
            "
            @click="goToNotify()"
          >
            <el-tooltip content="Notify" placement="right" effect="dark">
              <router-link to="/notify"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-commenting-o" aria-hidden="true"></i></span
                >{{ $t("notify") }}
              </router-link>
            </el-tooltip>
          </li>

          <li v-if="getPower('support')">
            <el-tooltip content="Support" placement="right" effect="dark">
              <a
                :href="support_site_url"
                target="_blank"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-life-ring" aria-hidden="true"></i></span
                >{{ $t("support") }}
              </a>
            </el-tooltip>
          </li>

          <li v-if="getPower('status-icon')">
            <el-tooltip content="Status" placement="right" effect="dark">
              <a href="https://callsteward.freshstatus.io/" target="_blank"
                ><span class="o-sidemenu-icon"
                  ><i
                    class="fa fa-exclamation-triangle"
                    aria-hidden="true"
                  ></i></span
                >{{ $t("status") }}</a
              >
            </el-tooltip>
          </li>

          <li v-if="userRoleSlug=='client-admin' || billing_employee"
            @click="goToInvoices()">
            <el-tooltip content="Invoice" placement="right" effect="dark">
              <router-link to="/cs-invoices"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-dollar" aria-hidden="true"></i></span
                >CS Invoices
              </router-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <div v-else class="o-sidenav mainSidenav">
        <div class="o-logo-area">
          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer"
            ><img src="static/assets/images/logo.png"
          /></a>
        </div>
        <ul class="o-sidebar-menu o-sidebar-bg">
          <li @click="goToJobList()">
            <el-tooltip content="JobsEvents" placement="right" effect="dark">
              <router-link to="/jobList"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-briefcase" aria-hidden="true"></i
                ></span>
                {{ $t("jobs_events") }}</router-link
              >
            </el-tooltip>
          </li>

          <li>
            <el-tooltip content="EmployerCalendar" placement="right" effect="dark">
              <router-link to="/calendarEmployer">
                <span class="o-sidemenu-icon"
                  ><i class="fa fa-calendar" aria-hidden="true"></i
                ></span>
                {{ $t("calendar") }}</router-link
              >
            </el-tooltip>
          </li>
          <li @click="goToResumeEmployer()">
            <el-tooltip content="EmployerResume" placement="right" effect="dark">
              <router-link to="/resume"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-graduation-cap" aria-hidden="true"></i></span
                >{{ $t("resume") }}
              </router-link>
            </el-tooltip>
          </li>
          <li v-if="userRoleSlug == 'employer-admin'">
            <el-tooltip content="EmployerUser" placement="right" effect="dark">
              <router-link to="/employerUserList"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-users" aria-hidden="true"></i
                ></span>
                {{ $t("group_users") }}</router-link
              >
            </el-tooltip>
          </li>

          <li @click="goToVenue()" v-if="getPower('venue')">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <router-link to="/venue">
                <span class="o-sidemenu-icon">
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                </span>
                {{ $t("venue") }}
              </router-link>
            </el-tooltip>
          </li>

          <li @click="goToVenue()" v-else-if="userRoleSlug=='employer-admin' || userRoleSlug=='employer'">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <router-link to="/venue">
                <span class="o-sidemenu-icon">
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                </span>
                {{ $t("venue") }}
              </router-link>
            </el-tooltip>
          </li>

          <li>
            <el-tooltip content="Support" placement="right" effect="dark">
              <a
                :href="support_site_url"
                target="_blank"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-life-ring" aria-hidden="true"></i
                ></span>
                {{ $t("support") }}</a
              >
            </el-tooltip>
          </li>
        </ul>
      </div>
      <!-- <el-tooltip content="Calendar" placement="right" effect="dark">       -->
        <span
          class="o-sidebar-trigger js-sidebarTrigger" title="Triggers"
          @click="headerTrigger($event)"
          ><i class="fa fa-bars" aria-hidden="true"></i
        ></span>
      <!-- </el-tooltip> -->
    </div>
  </div>
</template>
<script>
import dateTimeConvert from "../timeConvert&Compare";
import { mapGetters, mapActions } from "vuex";
import service from "../services.js";
// import { translate, i18n } from '@/lang/i18n';
import i18n from "@/lang/i18n";

export default {
  data() {
    return {
      windowWidth: "",
      encodedEmpId: btoa(this.employeeId),
      isSteward: 0,
      isDispatcher: 0,
      hideMobileSwitch: true,
      client_logo_url: '',
      billing_employee: false,
      support_site_url: '',
      power_steward_enabled: 0,
      app_source: false,
      client_id: ''
    };
  },
  computed: {
    ...mapGetters({
      userToken: "userToken",
      userRole: "userRole",
      userClientID: "userClientID",
      subDomain: "getSubdomain",
      employeeId: "employeeId",
      userRoleSlug: "userRoleSlug",
      userEmail: 'userEmail',
      isBillingEmployee: 'isBillingEmployee',
      queryParamClientId: 'queryParamClientId',
      queryParamAppSource: 'queryParamAppSource'
    }),
    deviceDetector() {
        let userAgent = navigator.userAgent.toLowerCase();
        const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
        console.log("Hello 1234567890");
        console.log("desktop" != check ? !0 : !1);
        return("desktop" != check ? !0 : !1);
    },
    // selectedLang() {
    //     return localStorage.getItem("lang");
    // }
  },
  methods: {
    async getClientData() {
        // console.log(this.userRole);   
        // console.log(this.userRoleSlug);   
      if(this.userRoleSlug != 'employer-admin' ) {
        await service.get('client/' + this.userClientID, {
        'Authorization': this.userToken
        })
        .then((res) => {
          this.clientData = res.data.result;

          let billing_email = this.clientData.billing_email;

          this.support_site_url = this.clientData.support_site_url && this.clientData.support_site_url != '' ? this.clientData.support_site_url : 'http://support.callsteward.com/support/home';

          // console.log(this.support_site_url);

          this.billing_employee = this.userEmail==billing_email?true:false;

          this.power_steward_enabled = this.clientData.power_steward;
         
          this.$store.dispatch('setIsBillingEmployee', this.billing_employee);

          // console.log(this.isBillingEmployee);

          // console.log("Check");
          // console.log(this.clientData);
          this.client_logo_url = this.clientData.logo                      
        }).catch((err) => {
            console.log(err);
        });
      }
    },
    changeViewDevice() {
      console.log(this.queryParamAppSource,this.queryParamClientId);
      console.log(localStorage.getItem('queryParams'));
      // console.log("Device");
      let queryParams = JSON.parse(localStorage.getItem('queryParams'));
      if(queryParams) {
        this.app_source = queryParams.app_source ? queryParams.app_source : false;
        this.client_id = queryParams.client_id ?  queryParams.client_id : '';
      }
      if(queryParams && queryParams.app_source && queryParams.client_id != '') {
        console.log("Check he the url");
        window.location.href = 'https://cs3.me/confirm2';
      } else {
        window.location.href = window.location.href.split("#")[0] + "#/schedule/" + btoa(this.employeeId);
      }
    },
    testMeApi() {
      service
        .get('call/me', {
          Authorization: this.userToken
        })
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.$Progress.fail();
        });
    },
    checkSteward() {
      this.isSteward = null;
      service
        .get("employee/" + this.employeeId + "/checkSkill", {
          Authorization: this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        })
        .then((res) => {
          this.isSteward = res.data.result;
          // if(this.isSteward&&this.power_steward_enabled) {
          //   this.$cookies.set("powerSteward", this.power_steward_enabled, "23h");
          // }
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$Progress.fail();
        });
    },
    checkDispatcher() {
      this.isDispatcher = null;
      service
        .get("employee/" + this.employeeId + "/checkDispatchBySkill", {
          Authorization: this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        })
        .then((res) => {
          this.isDispatcher = res.data.result;
          this.$forceUpdate();
        })
        .catch((err) => {
          this.$Progress.fail();
        });
    },
    getPower(data) {
      return dateTimeConvert.checkAccess(data);
    },
    isFrelenceUser() {
      return dateTimeConvert.disabledFrelenceUser();
      // if(subDomain =='freelance' && userRoleSlug =='employee'){
      //     return false;
      // }
      // return true;
    },
    goToJobList() {
      this.$router.push({
        path: "/jobList",
      });
    },
    goToCalls() {
      this.$router.push({
        path: "/callList11",
      });
    },
    goToScedule() {
      //console.log(this.employeeId)
      this.$router.push({
        path: "/schedule/" + btoa(this.employeeId),
      });
    },
    goToEmployers() {
      this.$router.push({
        path: "/employerList",
      });
    },
    goToEmployees() {
      this.$router.push({
        path: "/employees",
      });
    },
    goToDailySchedule() {
      this.$router.push({
        path: "/dailySchedule",
      });
    },
    goToSkills() {
      this.$router.push({
        path: "/skills",
      });
    },
    goToFiles() {
      this.$router.push({
        path: "/files",
      });
    },
    goToNotify() {
      this.$router.push({
        path: "/notify",
      });
    },
    goToInvoices() {
      this.$router.push({
        path: "/cs-invoices",
      });
    },
    goToEmployee911Availability() {
      this.$router.push({
        path: "/911-availability",
      });
    },  
    goToVenue() {
      this.$router.push({
        path: "/venue",
      });
    },
    goToReport() {
      this.$router.push({
        path: "/new-report-list",
      });
    },
    goToCalendar() {
      this.$router.push({
        path: "/calendar",
      });
    },
    goToResume() {
      this.$router.push({
        path: "/resume",
      });
    },
    goToResumeEmployer() {
      let url = "https://resume.callsteward.com";
      window.open(url, "_blank");
    },
    gotTojobList() {
      this.$router.push({
        path: "/",
      });
    },
    headerTrigger(event=null) {
      this.windowWidth = $(window).width();
      const sidenavWidth = $(".mainSidenav").width();
      // console.log(event);
      if (this.windowWidth > 1080) {
        // o-client-logo
      // if (this.windowWidth < 1366) {
        //                    $('.js-sidebarTrigger').on('click', function() {

        if ($(".mainSidenav").hasClass("open")) {
          $(".mainSidenav").css("width", "60px").removeClass("open");
          $(".wrapper").css("margin-left", "60px");
          $(".o-sidebar-trigger").css("left", "75px");
          $(".o-header").css("width", $(".o-header").width() + 160 + "px");
          

          $(".o-sidebar-trigger")
            .children()
            .removeClass("fa-arrows-alt")
            .addClass("fa-bars");
          $(".o-sidebar-bg li a").attr("data-toggle", "popover");
          $('[data-toggle="popover"]').popover();
          $(".mainSidenav .o-client-logo").css("margin", '0');
          $(".mainSidenav .o-client-logo").css("margin-top", "10px");
        } else {
          //var updateSidenav = sidenavWidth;
          //console.log("click");
          $(".mainSidenav").css("width", "220px").addClass("open");
          $(".o-header").css("width", $(".o-header").width() - 160 + "px");
          //console.log($('.o-header').width(), $('.mainSidenav').width(), $('.o-header').width() - $('.mainSidenav').width())
          $(".wrapper").css("margin-left", "220px");
          $(".o-sidebar-trigger").css("left", "230px");
          $(".o-sidebar-trigger")
            .children()
            .removeClass("fa-bars")
            .addClass("fa-arrows-alt");
          $(".o-sidebar-bg li a").removeAttr("data-toggle", "popover");
          $(".o-client-logo").css("margin", '0');
          $(".o-client-logo").css("margin-left", "50px");
        }
        //                    });
      } else {
      }
    },
  },
  mounted() {
    if (this.windowWidth > 1366) {
      //console.log('sdvdfv');
      $(".mainSidenav").css("width", "220px").addClass("open");
      $(".mainSidenav .o-client-logo").css("margin", '0');
      $(".mainSidenav .o-client-logo").css("margin-top", "10px");
      $(".wrapper").css("margin-left", "220px");
      $(".js-sidebarTrigger")
        .children()
        .removeClass("fa-bars")
        .addClass("fa-arrows-alt");
      $(".o-header").css("width", this.windowWidth - 220);
      //$(".o-header").addClass('c-responsive-fixwidth');
      //$(".o-header").css('width', '68%');
      $(".js-sidebarTrigger").css("left", "230px");
    }
    // this.headerTrigger();
  },
  async created() {
    await this.getClientData();
    if (this.userRoleSlug == "employee") { 
      this.checkSteward();
      this.checkDispatcher();
    }
    this.windowWidth = $(window).width();
    this.encodedEmpId = btoa(this.employeeId);
  },
  async beforeCreate() {
    
  }
};
</script>
<style scoped>
.o-client-logo{
  width: 55px!important;
}
.margin-left-50 {
  margin-left: 50px!important;
}
.margin-top-10 {
  margin-top: 10px!important;
}
.view-change-button {
  margin-top: 5px;
  margin-left: 10px;
  height: 35px;
  width: 35px;
  color: #000000;
  background-color: #06a865;
  float: right;
  font-size: 25px;
  font-weight: bold;
  border: none;
}
.item {
  cursor: pointer;
}
.img-class-pointer {
  cursor: auto;
}

.sidebar {
  overflow: auto;
  max-height: 92%;
  overflow-x: hidden;
  height: auto;
  overflow-y: scroll;
  /* max-width: 58px; */
}

.sidebar::-webkit-scrollbar {
  display: none;
}

.sidebar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.o-sidemenu-icon {
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/sideNav.vue